import { apiClient } from '@/libs/axios';
import type { MutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export type ChangeAdminPasswordData = {
  password: string;
  password_confirmed: string;
};

export type ChangeAdminPasswordParams = {
  id: string;
  data: ChangeAdminPasswordData;
};

export const changeAdminPassword = async ({
  id,
  data,
}: ChangeAdminPasswordParams): Promise<void> => {
  return await apiClient.patch(`admin/${id}/password`, data);
};

export function changeAdminPasswordMutationOptions(): MutationOptions<
  void,
  AxiosError,
  ChangeAdminPasswordParams
> {
  return {
    mutationFn: changeAdminPassword,
  };
}
